import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FacetsFilteringService } from '@fgpp-ui/grid';
import { FilterOperator } from '@fgpp-ui/grid';
import { GridConfig } from '@fgpp-ui/grid';
import { StoreService } from '../../core/services/store.service';
import { UserSettingsService } from '../../core/user-settings/services/user-settings.service';
import { GridSearchRequest } from '../../grid/models/grid-search-request.model';
import { GridConfigService } from '../../grid/services/grid-config.service';
import { SearchRequestBuilderService } from '../../grid/services/search-request-builder.service';
import { SearchFilter } from '../../shared/models/search-filter.model';
import { FormatsService } from '../../shared/services/formats.service';
import { BreadcrumbsService } from '../../ui-components/services/breadcrumbs.service';
import { MessagesApiService } from './messages-api.service';
import { MessagesHelperService } from './messages-helper.service';
import { MessagesManagementService } from './messages-management.service';

@Injectable()
export class CallerMessagesManagementService extends MessagesManagementService {
  private _isCallerAuthenticated: boolean;
  private _filter: Array<SearchFilter>;

  get filter() {
    return this._filter;
  }

  set isCallerAuthenticated(value: boolean) {
    this._isCallerAuthenticated = value;
  }

  get isCallerAuthenticated(): boolean {
    return this._isCallerAuthenticated;
  }

  get defaultFilters(): Array<SearchFilter> {
    return this.filter;
  }

  private _callerAuthenticatedForMids = [];

  constructor(userSettingsService: UserSettingsService,
            breadcrumbsService: BreadcrumbsService,
            messagesHelperService: MessagesHelperService,
            gridConfigService: GridConfigService,
            messagesApiService: MessagesApiService,
            searchRequestBuilderService: SearchRequestBuilderService<GridSearchRequest>,
            formatsService: FormatsService,
            translateService: TranslateService,
            facetsFilteringService: FacetsFilteringService,
            private storeService: StoreService) {
    super(userSettingsService, breadcrumbsService, messagesHelperService, gridConfigService, messagesApiService,
      searchRequestBuilderService, formatsService, translateService, facetsFilteringService);
  }

  setFilter(mids) {
    const filters: Array<SearchFilter> = new Array<SearchFilter>();
    filters.push({ columnId: 'P_IS_HISTORY', operator: FilterOperator.NOT_EQUAL, value: ['2'] });
    filters.push({ columnId: 'P_MID', operator: FilterOperator.IN, value: mids });
    this._filter = filters;
    return filters;
  }

  getGridConfig(): GridConfig {
    const gridConfig = super.getGridConfig();
    gridConfig.filterButtons.facetsFilterBtnConfig.showButton = false;
    return gridConfig;
  }

  addCallerAuthenticatedForMids(mids: string[]): void {
    this._callerAuthenticatedForMids.push(...mids);

  }

  removeCallerAuthenticatedForMid(mid: string): void {
    const index = this._callerAuthenticatedForMids.indexOf(mid);
    if (index != -1) {
      this._callerAuthenticatedForMids.splice(index, 1);
    }
  }

  resetCallerAuthenticatedForMids(): void {
    this._callerAuthenticatedForMids = [];
  }

  isCallerAuthenticatedForMid(mid: string): boolean {
    if (this._isCallerAuthenticated) {
      return true;
    }
    return this._callerAuthenticatedForMids.includes(mid);
  }
}
